const {
  VITE_ENVIRONMENT: ENVIRONMENT,
  VITE_API_URL: API_URL,
  VITE_MAX_RETRY: MAX_RETRY,
  VITE_CLOUDFLARE_SITE_KEY: CLOUDFLARE_SITE_KEY,
  VITE_BASE_URL: BASE_URL,
  VITE_WORDPRESS_API_URL: WORDPRESS_API_URL,
  VITE_WORDPRESS_USERNAME: WORDPRESS_USERNAME,
  VITE_WORDPRESS_APPLICATION_PASSWORD: WORDPRESS_APPLICATION_PASSWORD,
  VITE_DASHBOARDS_URL: DASHBOARDS_URL,
  VITE_SHOPPER_BLOG_TAG_ID: SHOPPER_BLOG_TAG_ID,
  VITE_BUSINESS_BLOG_TAG_ID: BUSINESS_BLOG_TAG_ID,
  VITE_CAMPAIGN_MONITOR_API_URL: CAMPAIGN_MONITOR_API_URL,
  VITE_CAMPAIGN_MONITOR_API_KEY: CAMPAIGN_MONITOR_API_KEY,
  VITE_CAMPAIGN_MONITOR_SHOPPER_LIST: CAMPAIGN_MONITOR_SHOPPER_LIST,
  VITE_CAMPAIGN_MONITOR_BUSINESS_LIST: CAMPAIGN_MONITOR_BUSINESS_LIST,
} = import.meta.env;

export {
  ENVIRONMENT,
  API_URL,
  MAX_RETRY,
  CLOUDFLARE_SITE_KEY,
  BASE_URL,
  DASHBOARDS_URL,
  WORDPRESS_API_URL,
  WORDPRESS_USERNAME,
  WORDPRESS_APPLICATION_PASSWORD,
  SHOPPER_BLOG_TAG_ID,
  BUSINESS_BLOG_TAG_ID,
  CAMPAIGN_MONITOR_API_URL,
  CAMPAIGN_MONITOR_API_KEY,
  CAMPAIGN_MONITOR_SHOPPER_LIST,
  CAMPAIGN_MONITOR_BUSINESS_LIST,
};
